// extracted by mini-css-extract-plugin
module.exports = {"addButton":"Diagnoses_addButton__2qBBJ","container":"Diagnoses_container__26ZAM"};